import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { TrackingEvent } from 'webapp/enums/tracking';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class FirstBoardEditTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.FIRST_BOARD_EDIT;
	override trackEvent: TrackingEvent | '' = TrackingEvent.BUBBLE_FIRST_BOARD_EDIT;

	get id(): string {
		return TourId.FIRST_BOARD_EDIT;
	}

	override get keyForPersistantDone(): string {
		return FirstBoardEditTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.DOWN,
				attachTo: () => {
					return this.el;
				},
			},
		];
	}

	override start(): void {
		super.start();
		this.markDone(); // just one step, once seen, it's done
	}
}
